import { PlusOutlined, SearchOutlined } from '@ant-design/icons'
import { Button, Card, Input, Tabs } from 'antd'
import { useState } from 'react'
import { Link } from 'react-router-dom'
import { PageHeader } from '~/components/PageHeader'
import PastCourses from './PastCourses'
import UpcomingCourses from './UpcomingCourses'
import { useUrlQuery } from '~/hooks/useUrlParams'

const Courses = () => {
  const [filterInput, setFilterInput] = useState('')

  const { queryValue, setQueryValue } = useUrlQuery({ name: 'tab', defaultValue: 'upcoming-course' })

  return (
    <>
      <PageHeader
        className="radup-page-header"
        title="Events"
        extra={[
          <Input.Search
            key={1}
            placeholder="Search"
            allowClear
            enterButton={<SearchOutlined />}
            onSearch={setFilterInput}
          />,
          <Link key={2} to={'create'}>
            <Button type="primary">
              <PlusOutlined /> New event
            </Button>
          </Link>
        ]}
      />

      <Card>
        <Tabs
          activeKey={queryValue.at(0)}
          onChange={key => setQueryValue(key)}
          items={[
            {
              key: 'upcoming-course',
              label: 'Upcoming events',
              children: <UpcomingCourses filterInput={filterInput} />
            },
            {
              key: 'past-course',
              label: 'Past events',
              children: <PastCourses filterInput={filterInput} />
            }
          ]}
        />
      </Card>
    </>
  )
}

export default Courses
